import { render } from "./consuleDBi.vue?vue&type=template&id=6ab81bf4&scoped=true"
import script from "./consuleDBi.vue?vue&type=script&lang=js"
export * from "./consuleDBi.vue?vue&type=script&lang=js"

import "./consuleDBi.vue?vue&type=style&index=0&id=6ab81bf4&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab81bf4"]])

export default __exports__